/** Allow only http(s) and relative URLs used by JSON links/images. */
export function safeUrl(value) {
  if (typeof value !== 'string' || !value.trim()) return '';
  try {
    const url = new URL(value.trim(), document.baseURI);
    return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
  } catch {
    return '';
  }
}
/** URL validation plus attribute escaping for insertion into HTML strings. */
export function esc_url(value) {
  return esc_attr(safeUrl(value));
}
export function esc_attr(value) {
  const map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' };
  return String(value).replace(/[&<>"']/g, (character) => map[character]);
}
export function esc_html(value) {
  return esc_attr(value);
}

/** Read either an array or an ID-keyed JSON object. */
export async function fetchJsonItems(url) {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  const json = await response.json();
  return Array.isArray(json) ? json : Object.values(json || {});
}
